<template>
  <button @click="click"><span>{{ title }}</span></button>
</template>

<script>
  export default {
    name: "removeInvoiceButton",
    props: ['title', 'click']
  }
</script>

<style scoped>
  button {
    margin: .5em .4em .5em 0;
    cursor: pointer;
    border: 1px solid #74b2e2;
    background: #e4f1fb url(../../../../assets/ui-bg_glass_100_e4f1fb_1x400.png) 50% 50% repeat-x;
    border-radius: 6px;
    display: inline-block;
    position: relative;
    padding: 0;
    overflow: visible;
    align-items: flex-start;
    box-sizing: border-box;
    color: #2779aa;
    outline: none;
  }

  button:hover {
    color: #0070a3;
    border: 1px solid #aed0ea;
    background: #d7ebf9 url(../../../../assets/ui-bg_glass_80_d7ebf9_1x400.png) 50% 50% repeat-x;
  }

  button:active {
    color: #ffffff;
    border: 1px solid #2694e8;
    background: #3baae3 url(../../../../assets/ui-bg_glass_50_3baae3_1x400.png) 50% 50% repeat-x;
  }

  span {
    padding: .4em 1em;
    display: block;
    line-height: normal;
    font-weight: bold;
    text-align: center;
    font-size: 12px;
    font-family: Lucida Grande,Lucida Sans,Arial,sans-serif;
  }
</style>
